<template>
  <div>
  
    <div>
      <div>
      </div>
      <div class="w-full flex justify-between items-center">
        <div>
          <!-- {{eachEventInfo}} -->
          <h3><strong>{{ eachEventInfo.title }}</strong></h3>
        </div>
        <div class="flex justify-end" vs-align="flex-end">
          <vs-button
            radius
            v-if="validateTodayDate() <= 0"
            @click="editingEvent(eachEventInfo.id)"
            icon="edit"
            color="primary"
            class="mr-2"
            vs-type="flex"
            style="margin-right: 0"
          />
          <vs-button
                      v-if="validateTodayDate() <= 0"

            radius
            icon="delete"
            color="danger"
            vs-type="flex"
            style="margin-right: 0"
            @click="deleteEvent(eachEventInfo.id)"
          />
        </div>
        <!-- time and date -->
      </div>
      <strong>Description</strong>
      <p
        v-html="eachEventInfo.extendedProps.description"
        v-if="eachEventInfo.extendedProps.description"
      ></p>
    </div>

    <!-- teacher details -->
    <div class="flex flex-wrap my-6">
      <div class="teacher-info">
        <div>
          <feather-icon icon="MapPinIcon" />
        </div>
        <div class="ml-2">
          <strong>Start</strong>
          <p v-if="eachEventInfo.start">
          {{moment(eachEventInfo.start).format('YYYY-MM-DD')}}
          </p>
        </div>
      </div>
      <div class="teacher-info" v-if="eachEventInfo.end">
        <div>
          <feather-icon icon="CalendarIcon" />
        </div>
        <div class="ml-2">
          <strong>End</strong>
                    <p v-if="eachEventInfo.end">

          {{moment(eachEventInfo.end).format('YYYY-MM-DD')}}
          </p>
        </div>
      </div>
     
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import { deleteHolidayApi } from '@/api/schedulerApi.js'

export default {
  props: {
    eachEventInfo: {
      type: Object,
      required: true
    }
  },
  methods: {
    validateTodayDate () {
      const today = moment(new Date())
      const selectedDate = moment(this.eachEventInfo.start)
      const differenceDate = today.diff(selectedDate, 'days')
      return differenceDate
    },
    editingEvent (id) {
      this.$emit('editingEvent', id)
      
    },
    async deleteEvent (id) {
      
      try {
        const customer_id = this.$store.getters.customerId
        const payload = {
          holiday_id:id
        }
        await deleteHolidayApi(customer_id, payload)
        this.showSuccessMessage(
          'success',
          'Holiday Deleted Successfully',
          'success'
        )
        this.$emit('eventEmitDeleted', id)
      } catch (error) {
        
      }
    }
  }
}
</script>